module.exports = __webpack_public_path__ + "img/wayforpay_logo.2ae65847.png";